import {
  lifecycle,
  withProps,
  compose,
  withHandlers,
  withStateHandlers
} from "recompose";
import { withRouter } from "react-router-dom";
import { push } from "react-router-redux";
import { parse, stringify } from "query-string";
import { createStructuredSelector } from "reselect";
import { isEmpty, omit } from "ramda";
import { connect } from "react-redux";
import { candidate } from "routes/paths";
import { fetchApi } from "core/api/hoc";
import { createLoadingSelector } from "core/helpers";
import { withActions } from "core/redux/hoc";
import * as api from "modules/insiders/api";
import * as model from "modules/insiders/model";
import * as hoc from "modules/user/auth/hoc";
import * as mixpanel from "core/integrations/mixpanel";
import * as fbPixel from "core/integrations/fb_pixel";
import * as dataLayer from "core/integrations/gtm";
import * as insidersSelectors from "modules/insiders/selectors";
import * as userSelectors from "modules/user/auth/selectors";
import View from "./View";

export default compose(
  hoc.withUserData,
  withRouter,
  fetchApi(api.getInsiders, ({ location, page }) => ({
    payload: {
      filter: parse(location.search).filter,
      ordering: parse(location.search).ordering
    }
  })),
  fetchApi(api.getFilters, () => ({
    selector: insidersSelectors.getFiltersApi,
    key: "filtersList"
  })),
  connect(
    createStructuredSelector({
      filters: insidersSelectors.getFilters,
      rawFilters: insidersSelectors.getFiltersApi,
      insiders: insidersSelectors.fetchInsiders,
      askSuggestionApi: insidersSelectors.askSuggestionApi,
      isLoading: createLoadingSelector(insidersSelectors.getInsidersApi),
      userDataApi: userSelectors.fetchUserDataApi
    }),
    {
      onAskClick: () => {
        mixpanel.trackEvent("user ask for a suggestion");
        fbPixel.fbq("trackCustom", "AskForSuggestion");
        dataLayer.push({
          event: "askForSuggestion"
        });
        return api.askSuggestion.request();
      },
      loadMoreInsiders: page =>
        api.getInsiders.request({
          page: page,
          filter: parse(document.location.search).filter,
          ordering: parse(document.location.search).ordering
        })
    }
  ),
  withProps(({ location }) => {
    const { filter, ordering } = parse(location.search, {
      decode: false
    });
    return {
      selected: filter ? model.decodeFilters(filter) : {},
      selectedOrder: ordering ? { criteria: ordering } : {}
    };
  }),
  withActions({
    updateSelection: ({ selected, location, selectedOrder }) => (
      filter,
      criteria = selectedOrder.criteria
    ) =>
      isEmpty(filter) && !criteria
        ? push(candidate.main)
        : push(
            candidate.main +
              `?${stringify(
                {
                  filter: model.encodeFilters(filter),
                  ordering: criteria
                },
                { encode: false }
              )}`
          ),
    fetchInsiders: () => search => {
      return api.getInsiders.request({
        filter: parse(search).filter,
        ordering: parse(search).ordering
      });
    }
  }),
  lifecycle({
    componentDidUpdate(prevProps) {
      if (prevProps.location.search !== this.props.location.search) {
        this.props.fetchInsiders(this.props.location.search);
      }
    }
  }),
  withHandlers({
    removeFilter: ({ selected, updateSelection }) => ({ field, value }) => {
      const result = selected[field].filter(v => v !== value);
      const updated = !result.length
        ? omit([field], selected)
        : {
            ...selected,
            [field]: result
          };

      return updateSelection(updated);
    }
  }),
  withHandlers({
    onFilterChange: ({ selected, updateSelection, removeFilter }) => ({
      field,
      value
    }) => {
      const group = selected[field] || [];
      const filter = group.find(v => v === value);
      if (filter) {
        return removeFilter({ field, value });
      }
      updateSelection({
        ...selected,
        [field]: [...group, value]
      });
      return mixpanel.trackEvent("Filter selection", {
        [field]: [...group, value],
        ...selected
      });
    },
    onFiltersSubmit: props => (field, items, raw) => {
      props.updateSelection({
        ...props.selected,
        [field]: items
      });
    },
    onClearAllFilters: ({ updateSelection }) => () => updateSelection({}),
    onOrderChange: ({ selected, updateSelection }) => ({ criteria }) => {
      updateSelection(selected, criteria);
    }
  }),
  withStateHandlers(() => ({ modalVisible: false }), {
    toggleModal: ({ modalVisible }) => () => ({ modalVisible: !modalVisible })
  })
)(View);



// WEBPACK FOOTER //
// ./src/components/pages/Candidate/InsidersList/Provider.js